import ConditionalRender from 'base/ConditionalRender/ConditionalRender';
import { StandardLoader } from 'base/Loader/Loader';
import { useState } from 'react';
import { Card, Form } from 'react-bootstrap';
import { SmtpConfigI } from '../../../types/interface';
import validationFunctions from 'utils/validationUtils';
import { SmtpConfigValidationSet } from 'utils/validations/ValidationsSet/SmtpConfigValidationSet';
import { t } from 'i18next';
import { capitalizeFirstLetter } from 'utils/helpers';
import { StandardButton } from 'base/StandardButton/StandardButton';
import StandardInput from 'base/StandardInput/StandardInput';
import StandardCheckbox from 'base/StandardCheckbox/StandardCheckbox';
import { useAppDispatch } from '../../redux/HooksRedux';
import * as smtpConfigAction from '../../redux/smtpConfig/smtpConfigAction';

export const SmtpConfig = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [formData, setFormData] = useState<SmtpConfigI>({
    host: '',
    pass: '',
    port: null,
    secure: false,
    user: '',
    to: '',
    from: ''
  });
  const [showError, setShowError] = useState(false);

  const dispatch = useAppDispatch();

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setIsLoading(true);
    const validation = validationFunctions.checkFormValidity(
      formData,
      SmtpConfigValidationSet
    );
    if (!validation) {
      setShowError(true);
      setIsLoading(false);
      return;
    }
    setShowError(true);
    setIsLoading(false);
    try {
      const response = await dispatch(
        smtpConfigAction.submitSmtpConfig(formData)
      );
    } catch (error) {
      console.log(error);
      setIsLoading(false);
    } finally {
      setIsLoading(false);
    }
  };

  const handleChange = (
    value: SmtpConfigI[keyof SmtpConfigI],
    field: keyof SmtpConfigI
  ) => {
    setFormData({ ...formData, [field]: value });
  };

  return (
    <Card id="smtp_config">
      <ConditionalRender condition={!isLoading} fallBack={<StandardLoader />}>
        <Form onSubmit={handleSubmit}>
          <Card.Header className="py-3">
            <div className="row justify-content-between align-items-center">
              <div className="w-auto">
                <h3>{capitalizeFirstLetter(t('smtp_config.title'))} </h3>
              </div>
              <div className="d-flex gap-2 w-auto">
                <StandardButton
                  onClick={() => {}}
                  buttonText={t('general.common_text.text_2')}
                  variant="danger"
                  type="submit"
                />
              </div>
            </div>
          </Card.Header>
          <Card.Body>
            <div className="row">
              <div className="col-12 col-md-6 col-lg-4">
                <StandardInput
                  className=""
                  onChange={value => handleChange(value, 'from')}
                  value={formData.from}
                  label={t('smtp_config.placeholder.text_7')}
                  type="text"
                  placeholder={t('smtp_config.placeholder.text_7')}
                  showError={showError}
                  validations={SmtpConfigValidationSet.from}
                />
              </div>
              <div className="col-12 col-md-6 col-lg-4">
                <StandardInput
                  className=""
                  onChange={value => handleChange(value, 'to')}
                  value={formData.to}
                  label={t('smtp_config.placeholder.text_6')}
                  type="text"
                  placeholder={t('smtp_config.placeholder.text_6')}
                  showError={showError}
                  validations={SmtpConfigValidationSet.to}
                />
              </div>
            </div>
            <div className="row">
              <div className="col-12 col-md-6 col-lg-4">
                <StandardInput
                  className=""
                  onChange={value => handleChange(value, 'host')}
                  value={formData.host}
                  label={t('smtp_config.placeholder.text_1')}
                  type="text"
                  placeholder={t('smtp_config.placeholder.text_1')}
                  showError={showError}
                  validations={SmtpConfigValidationSet.host}
                />
              </div>
              <div className="col-12 col-md-6 col-lg-4">
                <StandardInput
                  className=""
                  onChange={value =>
                    handleChange(parseInt(value as string), 'port')
                  }
                  value={formData.port as number}
                  label={t('smtp_config.placeholder.text_2')}
                  type="number"
                  placeholder={t('smtp_config.placeholder.text_2')}
                  showError={showError}
                  validations={SmtpConfigValidationSet.port}
                />
              </div>
              <div className="col-12 col-md-6 col-lg-4">
                <StandardInput
                  className=""
                  onChange={value => handleChange(value, 'user')}
                  value={formData.user}
                  label={t('smtp_config.placeholder.text_3')}
                  type="text"
                  placeholder={t('smtp_config.placeholder.text_3')}
                  showError={showError}
                  validations={SmtpConfigValidationSet.user}
                />
              </div>
              <div className="col-12 col-md-6 col-lg-4">
                <StandardInput
                  className=""
                  onChange={value => handleChange(value, 'pass')}
                  value={formData.pass}
                  label={t('general.common_text.text_3')}
                  type="password"
                  placeholder={t('general.common_text.text_3')}
                  showError={showError}
                  validations={SmtpConfigValidationSet.pass}
                />
              </div>
              <div className="col-12 col-md-6 col-lg-4 d-flex align-items-center ">
                <StandardCheckbox
                  className=""
                  isChecked={formData.secure}
                  label={t('smtp_config.placeholder.text_5')}
                  setChecked={value => handleChange(value, 'secure')}
                />
              </div>
            </div>
          </Card.Body>
        </Form>
      </ConditionalRender>
    </Card>
  );
};
